function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const colors = {
  error: "var(--error)",
  warning: "var(--warning)",
  information: "var(--info)",
  info: "var(--info)",
  success: "var(--success)",
  text: "var(--icon-secondary)",
  disabled: "var(--icon-primary-disabled)",
  "on-color": "var(--icon-on-color)"
};
const resolveParams = (color, size, style) => {
  const colorResolved = colors[color];
  let result = {
    ...style
  };
  if (colorResolved) {
    result["--icon-primary"] = colorResolved;
  }
  if (size) {
    result.height = size;
    result.width = size;
  }
  return result;
};
export const AnfIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Azure-NetApp-Files",
  width: 37,
  height: 37,
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Azure-NetApp-Files"
}, "Azure NetApp Files"), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  stroke: "#5933B4",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.2,
  fill: "#FFF",
  d: "M8.75 24.5h6.806v-8.4h3.888v8.4h6.806v-14H8.75z"
}), /*#__PURE__*/React.createElement("circle", {
  strokeWidth: 1.25,
  cx: 17.5,
  cy: 17.5,
  r: 17.5
})));
export const CvsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "NetApp-Cloud-Volumes-Service",
  width: 37,
  height: 37,
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "NetApp-Cloud-Volumes-Service"
}, "NetApp Cloud Volumes Service"), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  stroke: "#5933B4",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  strokeWidth: 1.25,
  cx: 17.5,
  cy: 17.5,
  r: 17.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.338 27.994c.422 0 .764-.24.764-.534 0-.295-.342-.534-.764-.534h-6.975c-.422 0-.764.239-.764.534 0 .295.342.534.764.534h6.975zM16.066 5.25c-2.755 0-5.059 2.02-5.528 4.675a4.86 4.86 0 00-4.413 4.853c0 2.701 2.169 4.892 4.843 4.892h11.18v-.883l-11.18-.147c-2.127 0-3.823-1.714-3.823-3.862 0-2.15 1.696-3.863 3.823-3.863a.512.512 0 00.51-.467c.231-2.338 2.205-4.168 4.588-4.168 1.298 0 2.359.507 3.202 1.384a.506.506 0 00.55.12c.368-.14.893-.216 1.346-.216a3.59 3.59 0 013.569 3.146c.022.195.152.36.334.426 1.457.54 2.47 1.956 2.47 3.638 0 2.148-1.697 3.862-3.824 3.862l-1.566.147v.883h1.566c2.674 0 4.843-2.19 4.843-4.892a4.861 4.861 0 00-2.86-4.45 4.619 4.619 0 00-4.532-3.79c-.462 0-.947.076-1.402.209-.982-.92-2.238-1.497-3.696-1.497zM10.915 23.5c0 .296.342.535.764.535h12.343c.422 0 .764-.24.764-.534 0-.295-.342-.534-.764-.534H11.679c-.422 0-.764.239-.764.534z",
  strokeWidth: 0.25,
  fill: "#5933B4",
  fillRule: "nonzero"
})));
export const NativeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Native",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 44,
  height: 44,
  viewBox: "0 0 44 44"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Native"
}, " Native"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#23A9FF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 20,
  strokeWidth: 2.053
}), /*#__PURE__*/React.createElement("path", {
  fill: "#25AAFF",
  d: "M29.063 28.685l-1.247 1.247-1.64-1.115-.263.196c-.722.526-1.575.854-2.428 1.05l-.328.065-.327 1.969h-1.772l-.394-1.902-.328-.067a8.952 8.952 0 0 1-2.493-.983l-.263-.197-1.64 1.115-1.313-1.246 1.116-1.641-.13-.197a7.178 7.178 0 0 1-1.05-2.428l-.067-.328-1.968-.328v-1.772l1.903-.393.065-.328a8.26 8.26 0 0 1 .984-2.493l.197-.263-1.115-1.641 1.247-1.246 1.64 1.115.262-.196c.722-.525 1.575-.853 2.428-1.051l.328-.065.328-1.968h1.772l.393 1.903.33.065a8.25 8.25 0 0 1 2.492.984l.262.198 1.641-1.182 1.246 1.247-1.115 1.64.197.262c.525.723.853 1.576 1.05 2.428l.065.328 1.97.328v1.772l-1.904.394-.066.328a9.004 9.004 0 0 1-.984 2.494l-.196.262 1.115 1.64zm.918-3.871l2.101-.394-.067-3.412-2.099-.328a6.477 6.477 0 0 0-.985-2.165l1.182-1.771-2.428-2.363-1.772 1.247c-.656-.394-1.443-.656-2.23-.853l-.394-2.231-3.413.066-.327 2.099a6.482 6.482 0 0 0-2.166.985l-1.77-1.182-2.363 2.428 1.246 1.77a9.28 9.28 0 0 0-.853 2.233l-2.1.393.066 3.412 2.1.329c.197.787.525 1.508.918 2.165l-1.18 1.77 2.427 2.363 1.772-1.247c.722.395 1.443.723 2.23.854l.395 2.099 3.411-.065.328-2.1a7.965 7.965 0 0 0 2.166-.92l1.772 1.182 2.361-2.428-1.246-1.771c.46-.656.787-1.378.918-2.165z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2AABF1",
  d: "M21.813 26.684h-.131c-2.166-.065-3.806-1.837-3.741-4.003a3.852 3.852 0 0 1 3.872-3.74h.13c2.166.066 3.807 1.838 3.74 4.003a3.852 3.852 0 0 1-3.87 3.74m.13-8.727h-.13c-2.625 0-4.79 2.1-4.855 4.724-.066 2.69 2.033 4.922 4.724 4.987h.13c2.626 0 4.79-2.1 4.856-4.724.066-2.624-2.034-4.921-4.724-4.987"
})));
export const OutlineIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Outline",
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  viewBox: "0 0 52 52"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Outline"
}, " Outline"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#f6f7f8",
  strokeWidth: 2.053
})));
export const NetAppHeaderLogoBlueIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Netapp-logo",
  width: "79px",
  height: "14px",
  viewBox: "0 0 79 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Netapp-logo"
}, " Netapp logo"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-36.000000, -100.000000)",
  fill: "#2C5E9C"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M76.266052,7.18615625 L76.266052,7.154875 C76.266052,5.73496875 75.2659942,4.79346875 74.0835058,4.79346875 C72.9028439,4.79346875 71.9187688,5.73496875 71.9187688,7.154875 L71.9187688,7.18615625 C71.9187688,8.60715625 72.9028439,9.54953125 74.0835058,9.54953125 C75.2659942,9.54953125 76.266052,8.6226875 76.266052,7.18615625 Z M69.4204509,2.893625 L71.952789,2.893625 L71.952789,4.12190625 C72.568578,3.3245625 73.4188555,2.7348125 74.7335434,2.7348125 C76.8160838,2.7348125 78.7967919,4.2984375 78.7967919,7.154875 L78.7967919,7.18615625 C78.7967919,10.04325 76.8489624,11.6070937 74.7335434,11.6070937 C73.383922,11.6070937 72.5507688,11.0166875 71.952789,10.3304687 L71.952789,14 L69.4204509,14 L69.4204509,2.893625 L69.4204509,2.893625 Z",
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-2",
  points: "19.1556734 0.19775 21.5227052 0.19775 26.9848931 7.154875 26.9848931 0.19775 29.5165462 0.19775 29.5165462 11.4485 27.3351416 11.4485 21.6891532 4.34503125 21.6891532 11.4485 19.1556734 11.4485 19.1556734 0.19775"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.0427803,6.50059375 C36.893685,5.4140625 36.2272081,4.680375 35.1625347,4.680375 C34.1115607,4.680375 33.4281879,5.40159375 33.2290896,6.50059375 L37.0427803,6.50059375 Z M30.7474393,7.21896875 L30.7474393,7.18615625 C30.7474393,4.74490625 32.5632977,2.7348125 35.1625347,2.7348125 C38.1426156,2.7348125 39.507763,4.9529375 39.507763,7.37865625 C39.507763,7.56940625 39.492922,7.7940625 39.4741994,8.01675 L33.2617399,8.01675 C33.5133526,9.1175 34.3113439,9.69303125 35.4447428,9.69303125 C36.2945636,9.69303125 36.9096676,9.43753125 37.6097081,8.81453125 L39.0572803,10.04325 C38.2259538,11.0330937 37.0261127,11.6390313 35.4118642,11.6390313 C32.7295173,11.6390313 30.7474393,9.8363125 30.7474393,7.21896875 L30.7474393,7.21896875 Z",
  id: "Fill-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.0889046,9.02059375 L41.0889046,4.9678125 L40.0233179,4.9678125 L40.0233179,2.893625 L41.0889046,2.893625 L41.0889046,0.70875 L43.6189595,0.70875 L43.6189595,2.893625 L45.7195376,2.893625 L45.7195376,4.9678125 L43.6189595,4.9678125 L43.6189595,8.6226875 C43.6189595,9.18115625 43.8703439,9.4530625 44.4356734,9.4530625 C44.9016821,9.4530625 45.3179162,9.3415 45.6857457,9.148125 L45.6857457,11.095875 C45.1523815,11.3999375 44.5343092,11.591125 43.6844884,11.591125 C42.1371387,11.591125 41.0889046,11.0000625 41.0889046,9.02059375",
  id: "Fill-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.8572312,7.18615625 L65.8572312,7.154875 C65.8572312,5.73496875 64.8576301,4.79346875 63.6765116,4.79346875 C62.4947081,4.79346875 61.5122312,5.73496875 61.5122312,7.154875 L61.5122312,7.18615625 C61.5122312,8.60715625 62.4947081,9.54953125 63.6765116,9.54953125 C64.8576301,9.54953125 65.8572312,8.6226875 65.8572312,7.18615625 Z M59.0141416,2.893625 L61.5453382,2.893625 L61.5453382,4.12190625 C62.1611272,3.3245625 63.0098064,2.7348125 64.3265491,2.7348125 C66.4090896,2.7348125 68.3897977,4.2984375 68.3897977,7.154875 L68.3897977,7.18615625 C68.3897977,10.04325 66.4419682,11.6070937 64.3265491,11.6070937 C62.9776127,11.6070937 62.1437746,11.0166875 61.5453382,10.3304687 L61.5453382,14 L59.0141416,14 L59.0141416,2.893625 L59.0141416,2.893625 Z",
  id: "Fill-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.8736618,6.77359375 L52.3253988,3.14803125 L50.7755376,6.77359375 L53.8736618,6.77359375 Z M51.2050145,0.19665625 L53.5097139,0.19665625 L58.3814566,11.4485 L55.7091561,11.4485 L54.635578,8.94140625 L50.0133931,8.94140625 L48.9471214,11.4485 L46.3335,11.4485 L51.2050145,0.19665625 L51.2050145,0.19665625 Z",
  id: "Fill-6"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-7",
  points: "0 0.1981875 0 11.4485 5.47976879 11.4485 5.47976879 4.6983125 8.611 4.6983125 8.611 11.4485 14.0907688 11.4485 14.0907688 0.1981875 0 0.1981875"
}))))));
export const NetAppLogoIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Netapp-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: 79,
  height: 14,
  viewBox: "0 0 79 14"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Netapp-logo"
}, " Netapp logo"), /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  d: "M76.266 7.186v-.031c0-1.42-1-2.362-2.182-2.362-1.181 0-2.165.942-2.165 2.362v.031c0 1.421.984 2.364 2.165 2.364 1.182 0 2.182-.927 2.182-2.364zM69.42 2.894h2.533v1.228c.616-.797 1.466-1.387 2.78-1.387 2.083 0 4.064 1.563 4.064 4.42v.031c0 2.857-1.948 4.421-4.063 4.421-1.35 0-2.183-.59-2.781-1.277V14H69.42V2.894zM19.156.198h2.367l5.462 6.957V.198h2.532v11.25h-2.182L21.69 4.345v7.103h-2.533V.198M37.043 6.5c-.15-1.086-.816-1.82-1.88-1.82-1.051 0-1.735.722-1.934 1.82h3.814zm-6.296.719v-.033c0-2.441 1.816-4.451 4.416-4.451 2.98 0 4.345 2.218 4.345 4.644 0 .19-.015.415-.034.638h-6.212c.251 1.1 1.05 1.676 2.183 1.676.85 0 1.465-.255 2.165-.878l1.447 1.228c-.831.99-2.03 1.596-3.645 1.596-2.682 0-4.665-1.803-4.665-4.42zM41.089 9.02V4.969h-1.066V2.894h1.066V.709h2.53v2.185h2.1v2.074h-2.1v3.655c0 .558.251.83.817.83.466 0 .882-.111 1.25-.305v1.948c-.534.304-1.152.495-2.002.495-1.547 0-2.595-.59-2.595-2.57M65.857 7.186v-.031c0-1.42-1-2.362-2.18-2.362-1.182 0-2.165.942-2.165 2.362v.031c0 1.421.983 2.364 2.165 2.364 1.18 0 2.18-.927 2.18-2.364zm-6.843-4.292h2.531v1.228c.616-.797 1.465-1.387 2.782-1.387 2.082 0 4.063 1.563 4.063 4.42v.031c0 2.857-1.948 4.421-4.063 4.421-1.35 0-2.183-.59-2.782-1.277V14h-2.53V2.894zM53.874 6.774l-1.549-3.626-1.55 3.626h3.099zM51.205.197h2.305l4.871 11.251H55.71l-1.073-2.507h-4.623l-1.066 2.507h-2.614L51.206.197zM0 .198v11.25h5.48v-6.75H8.61v6.75h5.48V.198H0"
}));
export const NetAppNIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Netapp-logo",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.10000000149011612 0.10000000149011612 42.900001525878906 36.900001525878906"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Netapp-logo"
}, " Netapp logo"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M.1.1V37h17V15.2h8V37H43V.1z"
}));